/*
 * Copyright (c) 2020 JCA Electronics , Winnipeg, MB. All rights reserved.
 */
// To parse this data:
//
//   import { Convert, MissionPlan } from "./file";
//
//   const missionPlan = Convert.toMissionPlan(json);
//SmartMap.Common.Mission.IMissionPlan
import { PartField } from './PartField';
import { Boundary } from './Boundary';
import { SimplePath } from './SimplePath';
import { MachineKey } from './MachineKey';
import { StagingArea } from './StagingArea';

export interface MissionPlan {
  MissionId: string;
  OriginLocation: { [key: string]: number | null };
  MissionName: string;
  ExclusionZones: Boundary[];
  Boundary: Boundary;
  PartFields: PartField[];
  StagingAreas: StagingArea[];
  PlannedPaths: SimplePath[];
  Fleet: MachineKey[];
  ImplementCode: null;
  Parameters: null;
}

export interface RasterStandardModel {
  Base64StringImage: string;
  GridX: number;
  GridY: number;
  NorthEastLatitude: number;
  NorthEastLongitude: number;
  SouthWestLatitude: number;
  SouthWestLongitude: number;
  Type: number;
  MachineKey: number;
}
// Converts JSON strings to/from your types
export class Convert {
  public static toMissionPlan(json: string): MissionPlan {
    return JSON.parse(json);
  }

  public static missionPlanToJson(value: MissionPlan): string {
    return JSON.stringify(value);
  }

  public static toRasterStandardModel(json: string): RasterStandardModel {
    return JSON.parse(json);
  }

  public static rasterStandardModelToJson(value: RasterStandardModel): string {
    return JSON.stringify(value);
  }
}
